import { callApi } from '@local_modules/generic/fetch.js'
import htmlTemplateIndex from './index.html'
import { setElementHtml } from '../../../../helpers/generic-js/dom.js'

const creationFormElementId = 'formAccountCreation'

export function showCreateAccountForm (containerId, parentElement) {
  setElementHtml(containerId, htmlTemplateIndex)

  addListener(parentElement)
}

function addListener (parentElement) {
  const creationFormElement = document.getElementById(creationFormElementId)
  if (!creationFormElement) return

  creationFormElement.addEventListener('submit', function (submitEvent) {
    console.log('form submitEvent', submitEvent)
    submitEvent.preventDefault()

    const submitButtonElement = creationFormElement.querySelector('button[type="submit"]')
    // ?.setAttribute('disabled', 'disabled')
    submitButtonElement.disabled = true

    createUserAccount(parentElement)
  })
}

async function createUserAccount (parentElement) {
  const creationFormElement = document.getElementById(creationFormElementId)
  const nameElement = creationFormElement.querySelector('#accountName')
  if (!nameElement) return

  console.log('createUserAccount, nameElement', nameElement.value)
  const postBody = {
    name: nameElement.value
  }

  const apiUrl = '/api/app-account/create'
  const responseData = await callApi(apiUrl, null, {
    method: 'POST',
    body: JSON.stringify(postBody)
  })
  console.log('showUserAccounts response', responseData)

  // Reset
  nameElement.value = ''

  // Inform the parent module
  parentElement.dispatchEvent(new Event('userAccountCreated'))
  return responseData
}
